export function formatCPFOrCNPJ(cpfCnpj) {
	if (!cpfCnpj || !cpfCnpj.length) {
		return cpfCnpj;
	}
	switch (cpfCnpj.length) {
		case 14:
			return cpfCnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
		case 11:
			return cpfCnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
		case 8:
			return cpfCnpj.replace(/^(\d{2})(\d{3})(\d{3})$/, '$1.$2.$3');
		default:
			return '';
	}
}

export function formatTel(tel) {
	if (!tel || !tel.length) {
		return tel;
	}
	if (tel.charAt(0) === '8'){
		tel = 0+tel;
		return tel.replace(/^(\d{4})(\d{3})(\d{4})$/, '$1-$2-$3');

	}
	switch (tel.length) {
		case 11:
			return tel.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
		case 10:
			return tel.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
		default:
			return '';
	}
}

export function formatCEP(cep) {
	if (!cep || !cep.length) {
		return cep;
	}
	switch (cep.length) {
		case 8:
			return cep.replace(/^(\d{5})(\d{3})$/, '$1-$2');
		default:
			return '';
	}
}

export function formatSexo(sexo){
	if (!sexo || !sexo.length) {
		return sexo;
	}
	switch(sexo){
		case 'm':
			return 'Masculino';
		case 'f':
			return 'Feminino';
		default:
			return sexo;
	}
}

export function ConvertBytes(bytes) {
	let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
	if (bytes === 0) return '0 Byte';
	let i = Math.floor(Math.log(bytes) / Math.log(1024));
	if(!bytes){
		return 0
	}
	return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}



// WEBPACK FOOTER //
// ./src/utils/format.js